module.exports = __webpack_public_path__ + "img/sentiment_very_dissatisfied_black_48dp.48ee9c54.svg";